var map = {
	"./green-4seat.png": 9860,
	"./green-5seat.png": 4065,
	"./green-aion-yplus.png": 4504,
	"./green-bigbee.png": 4845,
	"./green-byd.png": 8856,
	"./green-bz3x.png": 949,
	"./green-eqm5.png": 5256,
	"./green-ford.png": 3369,
	"./green-hybrid.png": 3640,
	"./green-kaiyi.png": 2656,
	"./green-mifa7.png": 7718,
	"./green-wheel.png": 5200,
	"./green-wuling-cloud.png": 8538,
	"./green-wuling-darion.png": 8509,
	"./red-4seat.png": 590,
	"./red-5seat.png": 9384,
	"./red-aion-e9.png": 5095,
	"./red-aion-yplus.png": 5526,
	"./red-bigbee.png": 6377,
	"./red-byd.png": 5078,
	"./red-bz3x.png": 8269,
	"./red-eqm5.png": 2363,
	"./red-ford.png": 1716,
	"./red-gse-eveasy.png": 1149,
	"./red-hybrid.png": 5280,
	"./red-kaiyi.png": 3401,
	"./red-mifa7.png": 4970,
	"./red-wheel-old.png": 8585,
	"./red-wheel.png": 9729,
	"./red-wuling-cloud.png": 8278,
	"./red-wuling-darion.png": 9286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2299;